const formatOptions = {
  "YYYY.MM.DD": {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
  long: {
    month: "long",
    day: "numeric",
    year: "numeric",
  },
} as const

const formatDate = ({
  date,
  format = "YYYY.MM.DD",
  timeZone,
}: {
  date: Date | string
  format?: keyof typeof formatOptions
  timeZone?: "UTC"
}) => {
  try {
    // Date-only strings ("YYYY-MM-DD" or "YYYY.MM.DD") are parsed as UTC by
    // the JS Date constructor, so always format them in UTC to avoid the
    // displayed date shifting by one day for users west of UTC.
    let resolvedTimeZone = timeZone
    if (typeof date === "string") {
      if (/^\d{4}[.\-]\d{2}[.\-]\d{2}$/.test(date)) {
        resolvedTimeZone ??= "UTC"
        date = date.replace(/\./g, "-")
      }

      date = new Date(date)
    }

    // Check if the date is a valid Date object
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      throw new Error("Invalid date.")
    }

    // The format will be "YYYY-MM-DD" for "en-CA"
    const dateFormatter = new Intl.DateTimeFormat("en-CA", {
      ...formatOptions[format],
      timeZone: resolvedTimeZone,
    })

    const formattedDate = dateFormatter.format(date)

    // Replace dashes with periods
    if (format === "YYYY.MM.DD") {
      return formattedDate.replace(/-/g, ".")
    }

    return formattedDate
  } catch (error) {
    console.error(error)
    return undefined
  }
}

export default formatDate
